import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { useFromToDateOnly } from './from-to-date-only.controller';

export interface FromToDateOnlyProps {
    fromDate: string | null;
    toDate: string | null;
    onFromDateChange: (date: string | null) => void;
    onToDateChange: (date: string | null) => void;
}

export const FromToDateOnly = (props: FromToDateOnlyProps) => {
    const viewProps = useFromToDateOnly(props);

    return (
        <div className='flex flex-col items-start justify-start gap-2'>
            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                <div className='text-foreground-default justify-start text-sm font-medium'>{CommonMessage.FORMS.FROM_TIMESTAMP}</div>
                <div className='bg-background-surface outline-border-default inline-flex h-11 w-full items-center justify-start gap-2 self-stretch overflow-hidden rounded-md px-4 outline-1 outline-offset-[-1px]'>
                    <input
                        placeholder={new Date().toLocaleDateString()}
                        onClick={(e) => e.currentTarget.showPicker()}
                        type='date'
                        className='text-foreground-default w-full border-none bg-transparent outline-none'
                        onChange={(e) => viewProps.handleDateChange(e, 'from')}
                        value={viewProps.fromDate ? viewProps.fromDate.split('T')[0] : ''}
                    />
                    <div className='flex items-center justify-end gap-2'>
                        {viewProps.fromDate && (
                            <ICONS.BUTTON.CLOSE
                                className='text-foreground-default cursor-pointer'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    props.onFromDateChange(null);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                <div className='text-foreground-default justify-start text-sm font-medium'>{CommonMessage.FORMS.TO_TIMESTAMP}</div>
                <div className='bg-background-surface outline-border-default inline-flex h-11 w-full items-center justify-start gap-2 self-stretch overflow-hidden rounded-md px-4 outline-1 outline-offset-[-1px]'>
                    <input
                        placeholder={new Date().toLocaleDateString()}
                        onClick={(e) => e.currentTarget.showPicker()}
                        type='date'
                        className='text-foreground-default w-full border-none bg-transparent outline-none'
                        onChange={(e) => viewProps.handleDateChange(e, 'to')}
                        value={viewProps.toDate ? viewProps.toDate.split('T')[0] : ''}
                    />
                    <div className='flex items-center justify-end gap-2'>
                        {viewProps.toDate && (
                            <ICONS.BUTTON.CLOSE
                                className='text-foreground-default cursor-pointer'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    props.onToDateChange(null);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
